import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  loadData
} from '../../actions/client';
import {
  NF_TEST,
  LA_TEST,
  RR_TEST,
  BS_TEST,
  LF_TEST,
} from '../../constants.js';
import Welcome from './Welcome';
import Tests from './Tests';
import LossAversion from './LossAversion';
import LossAversionLight from './LossAversionLight';
import RetirementRegret from './RetirementRegret';
import NarrowFraming from './NarrowFraming';
import BehavorialStressQuestion from './BehavioralStress';
import LossFrequency from './LossFrequency';
import s from './ClientMode.css';

class ClientMode extends PureComponent {

  componentWillMount() {
    this.props.loadData();
  }

  render() {
    const { testData, activeTest } = this.props;
    const showWelcome = false;
    const showTests = activeTest ? false : true;
    if(testData.id) {
      return (
        <div className={s.bhvfin}>
          <div className="row">
            <div className="col-md-12">
              <div className={s.headerTitle}>Behavioral Finance Tools</div>
            </div>
          </div>
          {showWelcome &&
            <Welcome />
          }
          {!showWelcome && showTests &&
            <Tests />
          }
          { activeTest === LA_TEST &&
            <LossAversionLight />
          }
          { activeTest === RR_TEST &&
            <RetirementRegret />
          }
          { activeTest === NF_TEST &&
            <NarrowFraming />
          }
          { activeTest === BS_TEST &&
            <BehavorialStressQuestion />
          }
          { activeTest === LF_TEST &&
            <LossFrequency />
          }
        </div>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    testData: state.clientData.testData,
    activeTest: state.clientData.activeTest,
  };
}

export default connect(mapStateToProps, {
  loadData,
})(ClientMode);



// WEBPACK FOOTER //
// ./src/components/ClientMode/ClientMode.js